/* eslint-disable camelcase */
import axios from 'axios';
import { USER_SETTINGS_ENDPOINT } from '@dynameat/constants';

export const userSettingsRequest = () => axios.get(USER_SETTINGS_ENDPOINT());
export const updateUserSettingsRequest = (userSettings) => axios.post(USER_SETTINGS_ENDPOINT(), userSettings);
